import type { CollectionTarget } from '../../../types/schedule.types';

export function deriveDepositBounds(options: {
    isDepositBearingMethod: boolean;
    isItemBasedDepositBearing: boolean;
    isItemBasedFamily: boolean;
    isDepositFixed: boolean;
    collectionTargets: CollectionTarget[];
    basketGrossMinor: number;
    maxDepositAmountMinor: number | undefined;
    depositMinor: number | undefined;
}): {
    firstTargetMinor: number | undefined;
    configuredMaxDepositMinor: number | undefined;
    effectiveMaxExclusive: number | undefined;
    configuredMaxBinds: boolean;
    naturalCeilingLabel: string;
    depositExceedsEffectiveMax: boolean;
} {
    const {
        isDepositBearingMethod,
        isItemBasedDepositBearing,
        isItemBasedFamily,
        isDepositFixed,
        collectionTargets,
        basketGrossMinor,
        maxDepositAmountMinor,
        depositMinor,
    } = options;

    const firstTargetMinor =
        isItemBasedFamily && collectionTargets.length > 0 ? collectionTargets[0].amount : undefined;

    const configuredMaxDepositMinor = isDepositBearingMethod ? maxDepositAmountMinor : undefined;

    // Configured max is inclusive; natural ceilings are exclusive — +1 converts before min().
    const configuredMaxExclusive =
        configuredMaxDepositMinor !== undefined ? configuredMaxDepositMinor + 1 : undefined;

    const naturalCeilingExclusive = isItemBasedDepositBearing ? firstTargetMinor : basketGrossMinor;

    const effectiveMaxExclusive =
        naturalCeilingExclusive === undefined
            ? undefined
            : configuredMaxExclusive === undefined
                ? naturalCeilingExclusive
                : Math.min(naturalCeilingExclusive, configuredMaxExclusive);

    const configuredMaxBinds =
        configuredMaxExclusive !== undefined &&
        naturalCeilingExclusive !== undefined &&
        configuredMaxExclusive <= naturalCeilingExclusive;

    const naturalCeilingLabel = isItemBasedDepositBearing
        ? 'the first collection target'
        : 'the plan total including VAT';

    const depositExceedsEffectiveMax =
        isDepositBearingMethod &&
        (isItemBasedDepositBearing || configuredMaxBinds || isDepositFixed) &&
        depositMinor !== undefined &&
        effectiveMaxExclusive !== undefined &&
        depositMinor >= effectiveMaxExclusive;

    return {
        firstTargetMinor,
        configuredMaxDepositMinor,
        effectiveMaxExclusive,
        configuredMaxBinds,
        naturalCeilingLabel,
        depositExceedsEffectiveMax,
    };
}
